const normalizarCodigo = (value) =>
  String(value || "")
    .trim()
    .replace(/\s/g, "")
    .toUpperCase();

export const extraerVtoDesdeCb1 = (cb1) => {
  const raw = normalizarCodigo(cb1);

  // Caso ideal: viene con (15)
  const matchConParentesis = raw.match(/\(15\)(\d{6})/);
  if (matchConParentesis) return matchConParentesis[1];

  // Caso sin paréntesis:
  // Busca AI 15 + 6 dígitos, normalmente antes de AI 37
  const clean = raw.replace(/[()]/g, "");
  const matchSinParentesis = clean.match(/15(\d{6})(?=37|$)/);

  return matchSinParentesis ? matchSinParentesis[1] : null;
};

export const extraerLoteDesdeCb2 = (cb2) => {
  const raw = normalizarCodigo(cb2);

  // Caso ideal: viene con (10)
  const matchConParentesis = raw.match(/\(10\)(.+)$/);
  if (matchConParentesis) return matchConParentesis[1];

  // Caso sin paréntesis: AI 10 al inicio
  const clean = raw.replace(/[()]/g, "");

  if (clean.startsWith("10")) {
    return clean.slice(2);
  }
  // Fallback: si por algún motivo no vino el AI, devuelvo el código limpio
  return clean || null;
};
